var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('tit', {
    staticClass: "tit--lg white--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 따스한 봄을 맞이하도록 도와드리겠습니다. "), _c('br'), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("봄은 다시 옵니다.")])]), _c('span', {
    staticClass: "line my-12px my-md-24px",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('txt', {
    staticClass: "white--text line-height-17",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('p', {
    staticClass: "mb-12px mb-md-24px"
  }, [_vm._v("이혼전문변호사 최유나입니다. 홈페이지를 찾아주셔서 감사합니다.")]), _c('p', [_vm._v("숱한 고민을 거쳐 어렵게 내리신 결정인 만큼, 의뢰인과의 충분한 공감과 소통을 통하여 최고의 법률서비스를 제공해 드리겠습니다. 소송 전 과정에서 의뢰인분의 한마디 한마디에 귀 기울이고, 경청하여 최상의 결과를 안겨드리고 새로운 삶으로 나아갈 수 있는 방향을 설정해 드리겠습니다.")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }